import React from 'react';

export const SidebarHeader = React.memo(() => {
  return (
    <div className='logo-wrapper'>
      <div className='logo' />
    </div>
  );
});
